export default "__VITE_ASSET__CnuzYM6___"